import React from "react";
import FlightSearchWidget from "@/components/site/FlightSearchWidget";
import PromoStrip from "@/components/site/PromoStrip";
import { Plane } from "lucide-react";

export default function FlightSearchPanel() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-10">
      <div className="bg-gradient-to-br from-[var(--brand-accent)] via-[var(--brand-primary-dark)] to-[var(--brand-primary)] rounded-3xl p-8 md:p-12 text-white shadow-xl shadow-teal-500/20 relative overflow-hidden">
        <div className="absolute -right-12 -top-12 w-72 h-72 rounded-full bg-white/5 blur-3xl pointer-events-none" />
        <div className="absolute -left-16 -bottom-16 w-72 h-72 rounded-full bg-teal-200/10 blur-3xl pointer-events-none" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-3 py-1 text-xs uppercase tracking-[0.2em] font-bold mb-4">
            <Plane className="w-3 h-3" /> Search · 700+ airlines · Live inventory
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight">Where to next?</h1>
          <p className="text-teal-100 mt-2 max-w-xl">Compare GDS, NDC and low-cost fares in one place. Book in minutes — manage anytime.</p>
        </div>
        <div className="relative mt-8">
          <FlightSearchWidget />
        </div>
      </div>
      <PromoStrip />
    </div>
  );
}
